import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-styled-flexboxgrid-tmp'
import * as R from 'ramda'


import CheckboxSquare from 'Components/Form/CheckboxSquare'
import ListingPreview, { extractListingPreviewProps } from 'Components/ListingPreview'

import ShareMenu from '../ShareMenu'
import NoFavourites from '../NoFavourites'

import {
  _ListingPreviewCol,
  _CheckBoxContainer,
} from './styles'

class FavListings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedListings: [],
    }
  }

  handleCheckChange(item) {
    let { selectedListings } = this.state
    const isIdMatched = R.propEq('id', item.id)
    const matchedListing = R.find(isIdMatched)(selectedListings)
    if(matchedListing) {
      selectedListings = R.reject(isIdMatched, selectedListings)
    } else {
      selectedListings.push(item)
    }
    this.setState({ selectedListings })
  }

  render() {
    const { selectedListings } = this.state
    const {
      allFavouriteListings,
      isFetching, openModal, googleAnalyticsEvent, isMobileApp, isUserAgentAdminSupport,
    } = this.props
    return (
      <div>
        <ShareMenu
          selectedListings={selectedListings}
          openModal={openModal}
          googleAnalyticsEvent={googleAnalyticsEvent}
          isMobileApp={isMobileApp}
          isUserAgentAdminSupport={isUserAgentAdminSupport}
        />
        <Row top="xs">
          {
            allFavouriteListings.length ?
              allFavouriteListings.map((item) => {
                const previewProps = extractListingPreviewProps(item)
                const isSelected = Boolean(R.find(R.propEq('id', item.id))(selectedListings))
                return (
                  <_ListingPreviewCol key={item.id}>
                    <_CheckBoxContainer onClick={this.handleCheckChange.bind(this, item)}>
                      <CheckboxSquare
                        uid={`selected-${item.title}`}
                        value={`selected-${item.title}`}
                        checked={isSelected}
                        iconSize={'medium'}
                        primaryCheckboxColor
                        onClick={() => null}
                      />
                      <span>{isSelected ? 'Selected' : 'Select'}</span>
                    </_CheckBoxContainer>
                    <ListingPreview
                      {...previewProps}
                      gridNumber={12}
                      isLocked={false}
                      sourcePage="Favourites"
                      userIsLoggedIn
                      HiddenCompareCta
                      isFavouritesPage
                    />

                  </_ListingPreviewCol>
                )
              })
              :
              <Col xs={12}>
                {
                  isFetching ?
                    'Loading...' :
                    <NoFavourites />
                }
              </Col>
          }
        </Row>
      </div>
    )
  }
}

FavListings.propTypes = {
  allFavouriteListings: PropTypes.arrayOf(PropTypes.shape({})),
  isFetching: PropTypes.bool.isRequired,
  openModal: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  isMobileApp: PropTypes.bool,
  isUserAgentAdminSupport: PropTypes.bool,
}

export default FavListings
